import React, { useEffect, useState } from 'react';
import { Prompt, useHistory, useRouteMatch } from 'react-router-dom';
import { FaSave } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { FormBuilder, FormStateBuilder } from '../../../components/FormBuilder';
import PageContainer from '../../../components/PageContainer';
import Loading from '../../../components/Loading';
import useAlertNotification from '../../../context/AlertNotificationContext';
import ErrorRequestService from '../../../services/errorRequest';
import FechamentoValidation from '../../../services/validation/FechamentoValidation';
import FechamentoApiService from '../../../services/api/FechamentoApiService';
import FechamentoNewInfo from './FechamentoNewInfo';
import { FechamentoNewHelpModal } from './FechamentoNewHelpModal';

function FechamentoNew(props) {
    // CONTEXT
    const history = useHistory();
    const match = useRouteMatch();
    const alert = useAlertNotification();

    // STATE
    const [origData, setOrginData] = useState(null);
    const [formFields, setFormFields] = useState(null);
    const [formData, setFormData] = useState(null);
    const [isEdited, setIsEdited] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    // FUNCTIONS
    const isFormEdited = () => {
        const jsonOrigData = JSON.stringify(origData);
        const jsonFormData = JSON.stringify(formData);
        return (jsonOrigData !== jsonFormData);
    }

    const askForLeave = (cbPositive, cbNegative=()=>{}) => {
        if (cbPositive instanceof Function) {
            const msg = 'Foram adicionados dados!\nDeseja realmente sair e perdê-los?';
            const leave = window.confirm(msg);

            if (leave) cbPositive();
            else cbNegative();
        }
        return false;
    }

    const saveForm = async() => {
        try {
            // valida os dados preenchidos
            const validation = await FechamentoValidation.validate(formData);
            if (!validation.isValid) {
                alert.error("Erros no formulário!");
                return;
            }

            // se ok, enviar dados p/ API
            const result = await FechamentoApiService.createNew(formData);

            if (result.data.result) {
                const { id } = result.data.result;
                setIsEdited(false);
                alert.success("Criado novo fechamento id: "+ id);
                // history.push(`${match.path.replace('/new','')}/${insertId}`);
                history.push( match.path.replace('/new','') );
            }
        }
        catch (err) {
            const errorService = new ErrorRequestService(err);
            const errorMsg = errorService.getErrors();
            console.log(errorMsg);
            alert.error(errorMsg);
        }
    }

    const handleCancel = () => {
        if (isEdited) {
            askForLeave(() => {
                setIsEdited(false);
                history.goBack()
            });
            return;
        }
        history.goBack();
    }

    const onChange = async  (ev) => {
        const { value, name } = ev.target;
        let newform = { ...formData, [name]: value };

        const getDataFormat = new Date(newform.dataInicio + "T12:00:00");

        if (getDataFormat.getDate() === 1 && typeof newform.dataFim != 'string') {
            const month = getDataFormat.getMonth() + 1;
            const year = getDataFormat.getFullYear();
            const lastDayOfMonth = new Date(year, month, 0).getDate();

            newform = { ...newform, dataFim: month < 10 ? `${year}-0${month}-${lastDayOfMonth}` :  `${year}-${month}-${lastDayOfMonth}`};
        }

        setFormData(newform);
    }

    const onEdit = () => {
        if (isFormEdited() && !isEdited) {
            setIsEdited(true);
        }
    }

    const onStart = () => {
        try {
            setIsLoading(true);
            const formFields = FechamentoNewInfo.getFormFields();
            const formData = FormStateBuilder(formFields );
            setOrginData( formData );
            setFormFields( formFields );
            setFormData( formData );
        }
        catch (err) {
            const errorService = new ErrorRequestService(err);
            const errorMsg = errorService.getErrors();
            console.log(errorMsg);
            alert.error(errorMsg);
        }
        finally {
            setIsLoading(false);
        }
    }

    // USEEFFECTS
    useEffect(onStart, []);
    useEffect(onEdit, [formData])

    const actions = [
        {
            label: 'Salvar',
            icon: <FaSave />,
            color: 'success',
            type: 'button',
            onClick: saveForm
        },
        {
            label: 'Cancelar',
            icon: <MdClose /> ,
            color: 'danger',
            type: 'button',
            onClick: handleCancel
        },
    ]

    const title = `Novo Fechamento`;

    return (
        <PageContainer
            title={title}
            actions={actions}
            infoButton={<FechamentoNewHelpModal />}
        >
            { isLoading
                ? <Loading message="Carregando..." />
                : ( formData &&
                    <FormBuilder
                        formFields={formFields}
                        formData={formData}
                        onChange={onChange}
                        initialValues={origData}
                        schema={FechamentoValidation.schema}
                    />
                )
            }

            <Prompt
                when={isEdited}
                message={location => askForLeave(() => {
                    setIsEdited(false);
                    setTimeout(() => {
                        history.push(location.pathname);
                    }, 100);
                })}
            />
        </PageContainer>
    )
}

export default FechamentoNew;
